import { usePwaInstallStore, type BeforeInstallPromptEvent } from '@/modules/pwa/stores/pwaInstallStore'
import { isPwaInstalled } from '@/modules/pwa/services/webpushClient'

function isIosSafari() {
  const ua = navigator.userAgent || (navigator as any).vendor
  const iOS = /iPad|iPhone|iPod/.test(ua)
  // New iPad on iOS 13+ pretends to be a Mac, extra check
  const iPadOS13 = navigator.platform === 'MacIntel' && (navigator as any).maxTouchPoints > 1
  const isSafari = /^((?!chrome|android).)*safari/i.test(ua)
  return (iOS || iPadOS13) && isSafari
}

let started = false

export function initInstallPromptListener() {
  if (started) return
  started = true
  if (typeof window === 'undefined') return

  try { usePwaInstallStore.getState().setIsIosSafari(isIosSafari()) } catch {}
  try { usePwaInstallStore.getState().setInstalled(isPwaInstalled()) } catch {}

  const onBeforePrompt = (e: Event) => {
    try { e.preventDefault?.() } catch {}
    usePwaInstallStore.getState().setDeferred(e as BeforeInstallPromptEvent)
  }

  const onAppInstalled = () => {
    const state = usePwaInstallStore.getState()
    state.setInstalled(true)
    state.setDeferred(null)
    state.setInstalling(false)
  }

  window.addEventListener('beforeinstallprompt', onBeforePrompt as any)
  window.addEventListener('appinstalled', onAppInstalled)
}

